export default __webpack_public_path__ + "/dist/images/695524.png";